<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      enable-resize-watcher
      fixed
      app
    >
      <side-drawer></side-drawer>
    </v-navigation-drawer>
    <v-toolbar
      app
      color="primary"
      class="elevation-1"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer" class="hidden-sm-and-up white--text"></v-toolbar-side-icon>
      <v-btn icon @click="goBack()" class="white--text">
        <v-icon>keyboard_arrow_left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-toolbar-title class="white--text">Sales Details</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu bottom left>
        <v-btn icon slot="activator" class="white--text">
          <v-icon>more_vert</v-icon>
        </v-btn>
        <v-list>
          <v-list-tile v-for="(item, i) in menuItems" :key="'menu' + i" @click="clickMenu(item.title)">
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-toolbar>
    <v-content>
      <v-layout>
        <v-flex xs12>
          <v-card class="pa-4">
            <v-layout align-center class="mb-5">
              <v-flex text-xs-center >
                <div class="headline font-weight-medium text-center pl-3 pr-3 pt-3">{{ salesOrderNo }}</div>
                <div class="body-2 font-weight-bold text-center pl-3 pr-3" v-if="invoiceNo">{{ invoiceNo }}</div>
                <div class="body-2 pl-3 pr-3 grey--text">{{ paidDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
              </v-flex>
            </v-layout>

            <div v-if="!((profile && (profile.storeType !== 'branch' && profile.storeType !== 'franchise') && (profile.storeParentType !== 'branch' && profile.storeParentType !== 'franchise')) && totalShippingWeight === 0)">
              <v-divider inset></v-divider>
              <v-list v-if="shippingEmail">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">perm_identity</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingTitle }} {{ shippingFirstName }} {{ shippingLastName }} - {{ shippingEmail }}
                  </v-list-tile-content>
                  <v-list-tile-action v-if="profile.storeType === 'branch'">
                    <v-btn
                      outline
                      small
                      color="primary"
                      class="pl-3 pr-3"
                      :to="'/ticket?buyer=' + buyerUserId + '&order=' + salesOrderNo"
                    >Send Msg</v-btn>
                  </v-list-tile-action>
                </v-list-tile>
              </v-list>
              <v-divider inset v-if="shippingEmail"></v-divider>
              <v-list v-if="shippingCompany">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">account_balance</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingCompany }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider v-if="shippingCompany" inset></v-divider>
              <v-list three-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">home</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingAddress }}
                    <v-list-tile-sub-title>{{ shippingCityName}}, {{ shippingPostCode }}, {{ shippingProvinceName }}, {{ shippingCountryName }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider inset></v-divider>
              <v-list>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">call</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingPhone }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
              <v-divider inset></v-divider>
              <v-list v-if="shippingEmail">
                <v-list-tile>
                  <v-list-tile-action>
                    <v-icon color="primary">email</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    {{ shippingEmail }}
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </div>
            <v-divider inset></v-divider>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">card_membership</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ orderType }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider inset></v-divider>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">attach_money</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <div v-if="paymentStatus == 'none' || paymentStatus == 'pending'">
                    Pending
                  </div>
                  <div v-else-if="paymentStatus == 'partial'">
                    Partial
                  </div>
                  <div v-else-if="paymentStatus == 'chargeback'" class="font-weight-bold red--text">
                    Chargeback
                  </div>
                  <div v-else-if="paymentStatus == 'credit'">
                    Credit
                  </div>
                  <div v-else>
                    Paid
                  </div>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider inset></v-divider>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">print</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <div v-if="isPrinted === '1'" class="blue--text text--darken-1">Printed on {{ printedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                  <div v-else class="grey--text">Not yet printed</div>
                  <v-list-tile-sub-title v-if="isPrinted === '1' && printedByUserEmail">By {{ printedByUserEmail }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider inset></v-divider>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">notification_important</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  Declare Value: {{ declareValuePercentage }}%
                  <v-list-tile-sub-title>Tax ID{{ (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') }}: {{ shippingTaxId }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider inset></v-divider>
            <v-list v-if="courierName">
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">local_shipping</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  {{ courierName }} - {{ serviceCode }}
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider inset v-if="courierName"></v-divider>
            <v-list>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">send</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <div v-if="deliveryStatus == 'pending'">
                    Pending
                  </div>
                  <div v-else-if="deliveryStatus == 'partial'">
                    Partial
                  </div>
                  <div v-else-if="deliveryStatus == 'sent'">
                    <v-icon color="green darken-2">check_circle_outline</v-icon>
                    Sent
                  </div>
                  <div v-else-if="deliveryStatus == 'delivered'">
                    Delivered
                  </div>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    v-if="deliveryStatus !== 'pending'"
                    outline
                    small
                    color="primary"
                    :disabled="deliveryStatus == 'pending'"
                    :to="'/shipments/' + salesOrderNo"
                  >View</v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-divider inset></v-divider>
            <v-list v-if="erp && erp.integrations && erp.sellerErpLastAttemptRequest">
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="primary">cloud</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <div v-if="erp && erp.sellerErpErrorCount && erp.sellerErpErrorCount > 0">
                    <div v-if="erp.sellerErpLastAttemptDateTime && erp.sellerErpLastAttemptDateTime !== ''">
                      ERP Sync Failed on {{ erp.sellerErpLastAttemptDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                    </div>
                    <div v-if="erp.sellerErpErrorMsg && erp.sellerErpErrorMsg !== ''" class="caption red--text">
                      {{ erp.sellerErpErrorMsg }}
                    </div>
                  </div>
                  <div v-else-if="erp && (erp.updatedInSellerErpDateTime || erp.createdInSellerErpDateTime)">
                    <div v-if="erp.updatedInSellerErpDateTime !== ''">
                      Synced to ERP on {{ erp.updatedInSellerErpDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                    </div>
                    <div v-else-if="erp.createdInSellerErpDateTime !== ''">
                      Synced to ERP on {{ erp.createdInSellerErpDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                    </div>
                    <div v-if="erp.sellerErpOrderNo && erp.sellerErpOrderNo !== ''" class="caption">
                      {{ erp.sellerErpOrderNo }}
                    </div>
                  </div>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn
                    outline
                    small
                    color="primary"
                    @click="dialogViewErpSyncDetails = true"
                  >View</v-btn>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
            <v-divider inset v-if="erp && erp.integrations && erp.sellerErpLastAttemptRequest"></v-divider>
            <div v-if="shippingLatitude !== 0 && shippingLongitude !== 0">
              <v-img :src="getStaticMapUrl(shippingLatitude, shippingLongitude, 200, 200, 16)" aspect-ratio="1" max-width="200" max-height="200" class="mt-3" style="border: 1px solid #ababab;"></v-img>
              <div>
                <v-btn
                  small
                  @click="showMapView"
                >
                  View
                </v-btn>
              </div>
            </div>

            <div v-if="isChargebackUser === '1'" class="mb-3">
              <v-container fluid grid-list-xs class="red darken-2 pa-3">
                <v-layout row wrap>
                  <v-flex xs3 sm1 class="text-xs-center">
                    <v-avatar>
                      <v-icon class="large notranslate white red--text">priority_high</v-icon>
                    </v-avatar>
                  </v-flex>
                  <v-flex xs9 sm11 class="white--text">
                    <h3 class="title font-weight-bold">Chargeback User</h3>
                    On {{ userChargebackDateTime | formatDate('DD MMMM YYYY', profile.gmtTimezone) }}
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <div style="overflow-y:auto;width:100%;min-height:100px;max-height:250px;border:1px solid #dedede;" class="pa-4 mt-5">
              <h3>Remarks</h3>
              <div v-html="(remarks ? remarks : '-')"></div>
            </div>

            <div style="overflow-y:auto;width:100%;min-height:250px;max-height:350px;border:1px solid #dedede;" class="pa-4 mt-5" ref="timelineDiv">
              <timeline>
                <timeline-title class="font-weight-bold title orange--text text--darken-1">Order Notes</timeline-title>
                <timeline-item v-for="(event, eventIndex) in events" :key="eventIndex" bg-color="#ff0000">
                  <span class="caption">{{ event.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                  <div class="font-weight-bold">{{ event.title }}</div>
                  <div v-html="event.description"></div>
                  <v-btn v-if="event.deliveryOrderNo"
                    outline
                    small
                    :href="'/shipment/' + event.deliveryOrderNo"
                    target="_blank"
                  >
                    View
                  </v-btn>
                </timeline-item>
              </timeline>
            </div>

            <div class="text-xs-left mt-5" v-if="userNotes.length > 0">
              <h4 class="title font-weight-bold mb-3 orange--text text--lighten-2">
                User Notes
              </h4>
              <v-container fluid grid-list-lg class="pa-0">
                <v-layout row wrap>
                  <v-flex xs12 v-for="note in userNotes" :key="note.userNoteId">
                    <div class="orange lighten-4 black--text pa-3 pb-5">
                      <div class="caption">
                        <span class="font-weight-bold">{{ note.createdDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                        <span v-if="note.updatedByAdminName" class="ml-2 mr-2">updated on {{ note.updatedDateTime | formatDate('DD MMM YYYY HH:mm', profile.gmtTimezone) }}</span>
                      </div>
                      <div class="subheading" v-html="note.note"></div>
                    </div>
                  </v-flex>
                </v-layout>
              </v-container>
            </div>

            <v-data-table
              :items="orderItems"
              hide-actions
              class="elevation-1 mt-5"
            >
              <template slot="headers">
                <tr class="grey lighten-4">
                  <th class="text-xs-left subheading font-weight-bold">
                    Item Name
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Sent Qty
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Qty
                  </th>
                  <th class="text-xs-center subheading font-weight-bold">
                    Total Price
                  </th>
                </tr>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <table>
                    <tr>
                      <td valign="top" class="item-name">
                        <img v-if="props.item.image" :src="props.item.image" class="item-thumb">
                        <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                      </td>
                      <td class="item-name">
                        <a :href="def.marketplaceDomain + props.item.url" class="black--text" target="_blank"><strong>{{ props.item.name }}</strong></a>
                        <div class="caption item-identity" :data-param-hash="props.item.paramHash">{{ props.item.sku }}</div>
                        <div v-if="props.item.locationCode">Location Code: {{ props.item.locationCode }}</div>
                        <div v-for="(param, paramIndex) in props.item.itemParams" :key="props.item.sku + props.item.paramHash + '-' + paramIndex">
                          <span class="font-weight-bold">{{ param.name }}: </span>
                          <span v-if="param.value">
                            <a v-if="param.value.toLowerCase().substring(0, 7) === 'http://' || param.value.toLowerCase().substring(0, 8) === 'https://'" :href="param.value" target="_blank">
                              {{ param.value }}
                            </a>
                            <span v-else>
                              {{ param.value }}
                            </span>
                          </span>
                          <div v-if="param.selections">
                            <div v-for="(selection, selectionIndex) in param.selections" :key="props.item.sku + props.item.paramHash + '-' + paramIndex + '-' + selectionIndex">
                              {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span>
                            </div>
                          </div>
                        </div>
                        <div v-for="option in props.item.options" :key="option.productOptionId">
                          <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                        </div>
                        <div class="mt-2" v-if="props.item.shippingSubsidyAmount && props.item.shippingSubsidyAmount > 0">
                          <span class="font-weight-bold green--text">{{ currencySign }}{{ formatPrice(props.item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                          with {{ props.item.shippingSubsidyCourierName }} {{ props.item.shippingSubsidyServiceName }}
                        </div>
                        <div v-if="props.item.qty === 0" class="mt-2 mb-3">
                          <span class="red white--text pa-1 font-weight-bold">
                            <v-icon small color="white">remove_circle_outline</v-icon>
                            This item has been removed
                          </span>
                        </div>
                        <div v-else-if="props.item.originalQty !== props.item.qty" class="mt-2 mb-3">
                          <span class="orange white--text pa-1 font-weight-bold">
                            <v-icon small color="white">error_outline</v-icon>
                            Qty has been modified from {{ props.item.originalQty }} to {{ props.item.qty }}
                          </span>
                        </div>
                        <div v-else-if="props.item.isAdditionalItem === '1'" class="mt-2 mb-3">
                          <span class="orange white--text pa-1 font-weight-bold">
                            <v-icon small color="white">error_outline</v-icon>
                            Additional item
                          </span>
                        </div>
                        <div v-if="props.item.itemPreparedBy" class="mt-3">
                          <div><span class="font-weight-medium">Prepared by:</span> <span class="primary--text font-weight-bold">{{ props.item.itemPreparedBy }}</span></div>
                          <div>
                            <span class="font-weight-medium">Seller has sent:</span> <span>{{ props.item.incomingQty }} of {{ props.item.qty }}</span>
                            <span v-if="props.item.incomingQty >= props.item.qty">
                              <v-icon small color="green lighten-2">check_circle_outline</v-icon>
                            </span>
                            <span v-else-if="props.item.incomingQty > 0">
                              <v-icon small color="orange darken-1">opacity</v-icon>
                            </span>
                            <span v-else>
                              <v-icon small>hourglass_empty</v-icon>
                            </span>
                            <div v-if="props.item.shipmentsToBranch.length > 0">
                              <ul v-for="shipment in props.item.shipmentsToBranch" :key="shipment.deliveryOrderNo">
                                <li>
                                  <router-link :to="'/shipment/' + shipment.deliveryOrderNo">
                                    View {{ shipment.deliveryOrderNo }}
                                  </router-link>
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>
                        <div>
                          <div v-if="props.item.issues.length > 0">
                            <div class="body-1 font-weight-bold mt-3">Issues:</div>
                            <div v-for="issue in props.item.issues" :key="issue.ticketId" class="mb-4">
                              <div class="font-weight-bold">{{ issue.title }}</div>
                              <div class="caption">By {{ issue.createdByUserStoreName }} ({{ issue.createdByUserTitle }} {{ issue.createdByUserFirstName }} {{ issue.createdByUserLastName }}) - {{ issue.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }} - <span v-if="issue.status === 'closed'" class="font-weight-bold green--text">{{ issue.status | allCaps }}</span><span v-else class="font-weight-bold red--text">{{ issue.status | allCaps }}</span></div>
                              <div class="caption">
                                <div v-for="msg in issue.messages" :key="msg.ticketMessageId">
                                  <v-divider class="mt-2 mb-2"></v-divider>
                                  <v-layout>
                                    <v-flex xs3 class="text-xs-center">
                                      <div v-if="msg.createdByUserId.length > 0">
                                        <div class="font-weight-bold">{{ msg.createdByUserStoreName }}</div>
                                        <div>{{ msg.createdByUserTitle }} {{ msg.createdByUserFirstName }} {{ msg.createdByUserLastName }}</div>
                                      </div>
                                      <div v-else-if="msg.createdByAdminId.length > 0">
                                        <div class="font-weight-bold">Admin</div>
                                        <div>{{ msg.createdByAdminName }}</div>
                                      </div>
                                    </v-flex>
                                    <v-flex xs9>
                                      <div>{{ msg.createdDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}</div>
                                      <div class="font-weight-bold" v-html="msg.message"></div>
                                      <div v-if="msg.files && msg.files.length > 0" class="text-xs-left mt-3">
                                        <div class="font-weight-bold">Uploaded files</div>
                                        <ul>
                                          <li v-for="file in msg.files" :key="file.ticketFileId">
                                            <a :href="file.url" class="grey--text text--darken-3">{{ file.fileName }}</a>
                                          </li>
                                        </ul>
                                      </div>
                                    </v-flex>
                                  </v-layout>
                                </div>
                                <v-divider class="mt-2 mb-2"></v-divider>
                                <v-btn
                                  outline
                                  small
                                  class="ml-0"
                                  @click="showReplyIssueDialog(issue.ticketId)"
                                >
                                  Reply
                                </v-btn>
                                <v-btn
                                  outline
                                  small
                                  class="ml-0"
                                  v-if="(profile.parentType === 'branch' || profile.type === 'branch') && issue.status === 'open'"
                                  @click="showCloseIssueDialog(issue.ticketId)"
                                >
                                  Close Case
                                </v-btn>
                                <v-btn
                                  outline
                                  small
                                  class="ml-0"
                                  v-if="(profile.parentType === 'branch' || profile.type === 'branch') && issue.status === 'closed'"
                                  @click="showReopenIssueDialog(issue.ticketId)"
                                >
                                  Reopen Case
                                </v-btn>
                              </div>
                            </div>
                          </div>
                          <div v-else>
                            <v-btn
                              outline
                              small
                              @click="showAddIssueDialog(props.item)"
                            >
                              Open issue
                            </v-btn>
                          </div>
                          <div v-if="checkItemIntegration(props.item)">
                            <v-btn
                              outline
                              small
                              @click="showItemIntegrationDialog(props.item)"
                            >
                              Connect to 3rd Party
                            </v-btn>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="caption text-xs-center">
                  <span v-if="props.item.qty === 0">
                    <v-icon medium color="red darken-1">remove_circle_outline</v-icon>
                    <br>Removed
                  </span>
                  <span v-else-if="props.item.sentQty >= props.item.qty">
                    <v-icon medium color="green lighten-2">check_circle_outline</v-icon>
                    <br>{{ props.item.sentQty }} sent
                  </span>
                  <span v-else-if="props.item.sentQty > 0">
                    <v-icon medium color="orange darken-1">opacity</v-icon>
                    <br>{{ props.item.sentQty }} sent
                  </span>
                  <span v-else>
                    <v-icon medium>hourglass_empty</v-icon>
                    <br>Pending
                  </span>
                </td>
                <td class="body-1 text-xs-center">
                  {{ (props.item.qty > 0 ? props.item.qty : props.item.originalQty) }}
                </td>
                <td class="body-1 text-xs-center font-weight-bold">
                  <div>{{ currencySign + formatPrice(props.item.totalPrice, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</div>
                  <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign + formatPrice(props.item.totalPrice * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign, def.currency.thousandSeparator) }}</div>
                  <div v-if="currencyCode !== profile.storeCurrencyCode && profile.storeCurrencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ profile.storeCurrencySign + formatPrice(props.item.totalPriceInBase / profile.storeCurrencyExchangeRateToBase, profile.storeCurrencyDecimals, profile.storeCurrencyDecimalSign, profile.storeCurrencyThousandSeparator) }}</div>
                </td>
              </template>
              <template slot="footer">
                <tr v-for="(item, index) in footers" :key="'footer' + index">
                  <td class="font-weight-bold">
                    {{ item.name }}
                  </td>
                  <td colspan="3" align="right" class="font-weight-bold">
                    <div>{{ currencySign + formatPrice(item.total, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</div>
                    <div v-if="currencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ def.currency.sign + formatPrice(item.total * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign, def.currency.thousandSeparator) }}</div>
                    <div v-if="currencyCode !== profile.storeCurrencyCode && profile.storeCurrencyCode !== def.currency.currencyCode" class="caption font-weight-light grey--text">{{ profile.storeCurrencySign + formatPrice(item.totalInBase / profile.storeCurrencyExchangeRateToBase, profile.storeCurrencyDecimals, profile.storeCurrencyDecimalSign, profile.storeCurrencyThousandSeparator) }}</div>
                  </td>
                </tr>
              </template>
            </v-data-table>

            <v-alert
              v-if="shippingSubsidyToBeCollected > 0"
              :value="true"
              color="orange"
              icon="info"
              class="mt-4"
              outline
            >
              Shipping subsidy of {{ currencySign + formatPrice(shippingSubsidyToBeCollected, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}
              ({{ def.currency.sign + formatPrice(shippingSubsidyToBeCollected * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign, def.currency.thousandSeparator) }})
              will be collected from your balance upon shipment
            </v-alert>

            <v-alert
              v-if="shippingSubsidyToReimburse > 0"
              :value="true"
              color="orange"
              icon="info"
              class="mt-4"
              outline
            >
              Shipping cost of {{ currencySign + formatPrice(shippingSubsidyToReimburse, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}
              ({{ def.currency.sign + formatPrice(shippingSubsidyToReimburse * exchangeRateToBase, def.currency.decimals, def.currency.decimalSign, def.currency.thousandSeparator) }})
              will be reimbursed to your balance upon shipment
            </v-alert>

            <v-btn
              :disabled="deliveryStatus === 'sent' || paymentStatus === 'chargeback' || isChargebackUser === '1'"
              block
              large
              color="primary"
              class="mt-4"
              @click="showShippingDialog"
            >Ship Order</v-btn>

          </v-card>
        </v-flex>
      </v-layout>
      <integration-ufi ref="integrationUfi"></integration-ufi>
      <v-dialog v-model="dialogShipment" @keydown.esc="dialogShipment = false" max-width="900px">
        <v-card>
          <v-card-title>
            <h3 class="headline font-weight-bold">Ship Order</h3>
          </v-card-title>
          <div style="overflow-y: scroll; max-height: 350px;">
            <v-data-table
              :headers="shipmentDialogHeaders"
              :items="orderItems"
              hide-actions
              class="elevation-1"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <table>
                    <tr>
                      <td valign="top" class="item-name">
                        <img v-if="props.item.image" :src="props.item.image" class="item-thumb">
                        <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
                      </td>
                      <td class="item-name">
                        <a :href="def.marketplaceDomain + props.item.url" class="black--text" target="_blank"><strong>{{ props.item.name }}</strong></a>
                        <div>{{ props.item.sku }}</div>
                        <div v-if="props.item.locationCode">Location Code: {{ props.item.locationCode }}</div>
                        <div v-for="(param, paramIndex) in props.item.itemParams" :key="'dialog' + props.item.sku + props.item.paramHash + '-' + paramIndex">
                          <span class="font-weight-medium">{{ param.name }}: </span>
                          <span v-if="param.value">{{ param.value }}</span>
                          <div v-if="param.selections">
                            <div v-for="(selection, selectionIndex) in param.selections" :key="'dialog' + props.item.sku + props.item.paramHash + '-' + paramIndex + '-' + selectionIndex">
                              {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span>
                            </div>
                          </div>
                        </div>
                        <div v-for="option in props.item.options" :key="'dialog' + option.productOptionId">
                          <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                        </div>
                        <div v-if="props.item.shippingSubsidyAmount && props.item.shippingSubsidyAmount > 0" class="mt-2 caption">
                          <span class="font-weight-bold green--text">{{ currencySign + formatPrice(props.item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                          with {{ props.item.shippingSubsidyCourierName }} {{ props.item.shippingSubsidyServiceName }}
                        </div>
                        <div v-if="props.item.itemPreparedBy" class="mt-3">
                          <div><span class="font-weight-medium">Prepared by:</span> <span class="primary--text font-weight-bold">{{ props.item.itemPreparedBy }}</span></div>
                          <div><span class="font-weight-medium">Seller has sent:</span> <span>{{ props.item.incomingQty }} of {{ props.item.qty }}</span></div>
                        </div>
                      </td>
                    </tr>
                  </table>
                </td>
                <td class="text-xs-center">
                  {{ props.item.sentQty }}
                </td>
                <td class="text-xs-center" style="min-width:100px;">
                  <div v-if="(profile.parentType === 'branch' || profile.type === 'branch') && props.item.isOpenIssue === 1">
                    <span class="red--text">Issue still open</span>
                  </div>
                  <div v-else-if="props.item.qty === props.item.sentQty || (props.item.shipViaSellerUserId === '' && props.item.availableQty <= 0)">
                    <span class="green--text">Item shipped</span>
                  </div>
                  <div v-else-if="props.item.shipViaSellerUserId !== '' && props.item.availableQty <= 0">
                    <span class="red--text">Still waiting for shipment</span>
                  </div>
                  <div v-else>
                    <v-autocomplete
                      :items="generateShippingQtyDropdown(props.item.availableQty)"
                      item-text="caption"
                      item-value="value"
                      label=""
                      v-model="props.item.shippingQty"
                      small
                      required
                    ></v-autocomplete>
                  </div>
                </td>
              </template>
            </v-data-table>
          </div>
          <v-card-text>
            <v-btn
              block
              large
              color="primary"
              v-if="couriers.length <= 0"
              @click="(validateShippingForm() === true ? getCourierRates() : '')"
            >
              Select Courier
            </v-btn>
            <v-form ref="frmShipment" v-model="frmShipmentValid" v-if="couriers.length > 0">
              <v-container fluid grid-list-xs>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="cboCourier"
                      :rules="[v => !!v || 'Please select a Courier']"
                      :items="couriers"
                      item-text="courierName"
                      item-value="courierId"
                      label="Courier"
                      @change="selectCourier(cboCourier)"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier !== 'CUSTOM'">
                    <v-select
                      v-model="cboService"
                      :rules="[v => !!v || 'Please select a service']"
                      :items="courierServices"
                      item-text="description"
                      item-value="service"
                      label="Service"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier === 'CUSTOM'">
                    <v-text-field
                      v-model="txtCustomCourierName"
                      :rules="[v => !!v || 'Custom courier name is required']"
                      label="Custom Courier Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 v-if="cboCourier === 'CUSTOM'">
                    <v-text-field
                      v-model="txtCustomTrackingUrl"
                      :rules="[v => !!v || 'Custom tracking URL is required']"
                      label="Custom Tracking URL"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <div v-if="cboCourier === 'COU-INSTANT' && cboService === 'EMAIL'">
                      Please fill in details about the virtual item
                    </div>
                    <trumbowyg
                      v-if="cboCourier === 'COU-INSTANT' && cboService === 'EMAIL'"
                      v-model='txtMessage'
                      :config="trumbowygConfig"
                    ></trumbowyg>
                    <v-text-field
                      v-else
                      v-model="txtTrackingNo"
                      :rules="[v => !!v || 'Tracking no is required']"
                      label="Tracking No"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <input
                      type="file"
                      multiple
                      style="display: none"
                      ref="filePicker"
                      accept="*"
                      @change="onFilePicked"
                      @click="$refs.filePicker.value = null"
                    >
                    <v-container fluid grid-list-xs>
                      <v-layout row wrap>
                        <v-flex xs3 sm1 class="mt-1">
                          <span class="font-weight-bold">Files</span>
                        </v-flex>
                        <v-flex xs9 sm11>
                          <v-chip
                            v-for="(file, fileIndex) in fileUploads"
                            :key="fileIndex"
                            @input="removeFileUpload(fileIndex)"
                            close
                          >
                            <v-avatar v-if="file.uploadStatus === 'success'">
                              <v-icon color="green">check_circle</v-icon>
                            </v-avatar>
                            <v-avatar v-else-if="file.uploadStatus === 'error'">
                              <v-icon color="red">error</v-icon>
                            </v-avatar>
                            <v-avatar v-else-if="file.uploadStatus === 'uploading'">
                              <v-icon color="orange">hourglass_full</v-icon>
                            </v-avatar>
                            {{ file.name }}
                          </v-chip>
                          <v-btn
                            outline
                            icon
                            small
                            v-if="fileUploads.length < 3"
                            class="ml-2 mr-0 mt-0 mb-0"
                            @click="pickFile"
                          >
                            <v-icon small>add</v-icon>
                          </v-btn>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-flex>
                  <v-flex xs12>
                    <v-btn
                      block
                      large
                      color="primary"
                      :disabled="!frmShipmentValid"
                      @click="shipOrder"
                    >
                      Confirm
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAcceptOrder" max-width="290">
        <v-card>
          <v-card-title class="headline">Confirmation</v-card-title>

          <v-card-text>
            Are you sure to accept this order?
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="secondary"
              class="grey--text"
              @click="dialogAcceptOrder = false"
            >
              Cancel
            </v-btn>

            <v-btn
              color="primary"
              @click="dialogAcceptOrder = false;"
            >
              Accept
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogAddIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Add Issue</v-card-title>
          <v-layout align-center v-if="issueItem">
            <v-flex xs3 text-xs-center>
              <img v-if="issueItem.image" :src="issueItem.image" class="item-thumb">
              <div v-else style="width:100%; height: 70px; border: 1px solid #ababab; padding: 15px 10px;">No Image</div>
            </v-flex>
            <v-flex xs9 text-xs-left>
              <div class="font-weight-bold black--text"><a :href="def.marketplaceDomain + issueItem.url" target="_blank">{{ issueItem.name }}</a></div>
              <div v-for="(param, paramIndex) in issueItem.itemParams" :key="'issue' + issueItem.sku + issueItem.paramHash + '-' + paramIndex">
                <span class="font-weight-medium">{{ param.name }}: </span>
                <span v-if="param.value">{{ param.value }}</span>
                <div v-if="param.selections">
                  <div v-for="(selection, selectionIndex) in param.selections" :key="'issue' + issueItem.sku + issueItem.paramHash + '-' + paramIndex + '-' + selectionIndex">
                    {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span>
                  </div>
                </div>
              </div>
              <div v-for="option in issueItem.options" :key="'issue' + option.productOptionId">
                <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
              </div>
              <div v-if="issueItem.itemPreparedBy && issueItem.itemPreparedBy.length > 0">
                <div class="caption black--text mt-3"><strong>Prepared by:</strong>{{ issueItem.itemPreparedBy }}</div>
                <div class="caption black--text"><strong>Seller has sent:</strong> {{ issueItem.incomingQty }} of {{ issueItem.qty }}</div>
              </div>
            </v-flex>
          </v-layout>

          <v-card-text>
            <v-form ref="frmAddIssue" v-model="frmAddIssueValid">
              <v-text-field
                v-model="txtIssueTitle"
                :rules="[v => !!v || 'Title is required']"
                label="Title"
                required
              ></v-text-field>
              <v-textarea
                v-model="txtIssueDetails"
                :rules="[v => !!v || 'Details is required']"
                label="Issue Details"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmAddIssueValid"
                @click="addIssue"
              >
                Submit Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogReplyIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Reply Message</v-card-title>
          <v-card-text>
            <v-form ref="frmReplyIssue" v-model="frmReplyIssueValid">
              <v-textarea
                v-model="txtReplyIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Reply Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmReplyIssueValid"
                @click="replyIssue"
              >
                Add Update
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogCloseIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Close Issue</v-card-title>
          <v-card-text>
            <v-form ref="frmCloseIssue" v-model="frmCloseIssueValid">
              <v-textarea
                v-model="txtCloseIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Closing Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmCloseIssueValid"
                @click="closeIssue"
              >
                Close Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogReopenIssue" max-width="500">
        <v-card>
          <v-card-title class="title font-weight-bold">Reopen Issue</v-card-title>
          <v-card-text>
            <v-form ref="frmReopenIssue" v-model="frmReopenIssueValid">
              <v-textarea
                v-model="txtReopenIssueMessage"
                :rules="[v => !!v || 'Message is required']"
                label="Reopen Message"
                auto-grow
                box
                required
              ></v-textarea>
              <v-btn
                block
                large
                color="primary"
                :disabled="!frmReopenIssueValid"
                @click="reopenIssue"
              >
                Reopen Issue
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogViewErpSyncDetails" max-width="1000" v-if="erp && erp.sellerErpLastAttemptRequest && erp.sellerErpLastAttemptResponse">
        <v-card>
          <v-card-title class="headline">ERP Sync Details</v-card-title>

          <v-card-text>
            <div class="font-weight-bold">Request</div>
            <div>{{ erp.sellerErpLastAttemptRequest }}</div>
            <div class="font-weight-bold mt-4">Response</div>
            <div>{{ erp.sellerErpLastAttemptResponse }}</div>
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="220"
      >
        <loading></loading>
      </v-dialog>
    </v-content>

    <div hidden="true">
      <div id='printMe' style="background-color: #f6f6f6; margin: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; box-sizing: border-box; font-size: 14px;">
        <table style="background-color: #fff; border: 1px solid #e9e9e9; border-radius: 3px; margin: 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; box-sizing: border-box; font-size: 14px;" width="100%" cellpadding="0" cellspacing="0">
          <tr>
            <td style="padding: 0; text-align: center;">
              <table style="margin: 10px auto; text-align: left; width: 80%;">
                <!--<tr>
                  <td align="center">
                    <img src="/static/img/logo-martview.jpg" style="width:100%; max-width:100px; margin-top: 20px;">
                  </td>
                </tr>-->
                <tr>
                  <td style="padding: 0 0 20px; text-align: left; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px;  line-height: 1.6em;">
                    <h1 style="text-align: center; font-size: 24px; font-family: 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif; color: #000; margin: 20px 0 0 0; line-height: 1.2em; font-weight: 400;">{{ invoiceNo }}</h1>
                    <h3 style="text-align: center; font-size: 12px; font-family: 'Helvetica Neue', Helvetica, Arial, 'Lucida Grande', sans-serif; color: #000; margin: 0; line-height: 1.2em; font-weight: 400;">{{ salesOrderNo }}</h3>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    {{ paidDateTime | formatDate('DD MMMM YYYY HH:mm', profile.gmtTimezone) }}
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    <span v-if="shippingFirstName"><strong>{{ shippingFirstName }} {{ shippingLastName }}</strong></span>
                    <span v-if="shippingCompany"><br><strong>{{ shippingCompany }}</strong></span>
                    <br>{{ shippingAddress }}
                    <br>{{ shippingCityName}}, {{ shippingPostCode }}, {{ shippingProvinceName }}
                    <br>{{ shippingCountryName }}
                    <br>{{ shippingPhone }}
                    <br>Tax ID{{ (shippingTaxIdLocalName.length > 0 ? ' (' + shippingTaxIdLocalName + ')' : '') }}: {{ shippingTaxId }}
                    <!--<br>{{ shippingEmail }}-->
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    <strong>Remarks:</strong>
                    <div v-html="(remarks ? remarks : '-')"></div>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                    Shipping Courier: <strong>{{ courierName }} - {{ serviceCode }}</strong>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 5px 0;">
                    <table style="width: 100%;" cellpadding="0" cellspacing="0">
                      <tr>
                        <td style="border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="3">
                        </td>
                      </tr>
                      <tr v-for="item in orderItems" :key="'print' + item.sku + item.paramHash">
                        <td style="padding: 20px 0 30px; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          <table style="width: 100%;" cellpadding="0" cellspacing="15">
                            <tr>
                              <td style="width: 60px;" valign="top">
                                <img v-if="item.image" :src="item.image" style="width: 60px; height: auto;">
                                <div v-else style="width:60px; height: 50px; border: 1px solid #333333; text-align: center; font-size: 11px; padding-top: 15px;">No Image</div>
                                <div style="font-size:10px;">{{ item.sku }}</div>
                              </td>
                              <td style="width: 100%;">
                                {{ item.name }}
                                <div v-if="item.locationCode">Location Code: {{ item.locationCode }}</div>
                                <div>@ {{ currencySign + formatPrice(item.unitPrice, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }} each</div>
                                <div v-for="(param, paramIndex) in item.itemParams" :key="'print' + item.sku + item.paramHash + '-' + paramIndex" style="padding-top:10px; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 12px;">
                                  <span><strong>{{ param.name }}: </strong></span>
                                  <span v-if="param.value">{{ param.value }}</span>
                                  <div v-if="param.selections">
                                    <div v-for="(selection, selectionIndex) in param.selections" :key="'print' + item.sku + item.paramHash + '-' + paramIndex + '-' + selectionIndex">
                                      {{ selection.name }} <span v-if="selection.priceInBase > 0">{{ currencySign + formatPrice(selection.priceInBase / exchangeRateToBase, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span><span v-else-if="selection.price > 0">{{ currencySign + formatPrice(selection.price, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}</span>
                                    </div>
                                  </div>
                                </div>
                                <div v-for="option in item.options" :key="'print' + option.productOptionId">
                                  <span class="font-weight-medium">{{ option.optionName }}:</span> <span>{{ option.valueName }}</span>
                                </div>
                                <div v-if="item.shippingSubsidyAmount && item.shippingSubsidyAmount > 0" style="font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 12px; line-height: 1.6em;">
                                  <span style="font-weight: 700;color: #376500">{{ currencySign + formatPrice(item.shippingSubsidyAmount, currencyDecimals, currencyDecimalSign) }} Free Shipping</span>
                                  with {{ item.shippingSubsidyCourierName }} {{ item.shippingSubsidyServiceName }}
                                </div>
                                <div v-if="item.qty === 0">
                                  <span style="color: #ff0000; font-weight: 700;">
                                    This item has been removed
                                  </span>
                                </div>
                                <div v-else-if="item.originalQty !== item.qty">
                                  <span style="color: #ff9900; font-weight: 700;">
                                    Qty has been modified from {{ item.originalQty }} to {{ item.qty }}
                                  </span>
                                </div>
                                <div v-else-if="item.isAdditionalItem === '1'">
                                  <span style="color: #ff9900; font-weight: 700;">
                                    Additional item
                                  </span>
                                </div>
                                <div v-if="item.itemPreparedBy" style="margin-top: 10px;">
                                  <div><span class="font-weight-medium">Prepared by:</span> <span style="color: #ff0000;"><strong>{{ item.itemPreparedBy }}</strong></span></div>
                                  <div><span class="font-weight-medium">Seller has sent:</span> <span>{{ item.incomingQty }} of {{ item.qty }}</span></div>
                                </div>
                              </td>
                            </tr>
                          </table>
                        </td>
                        <td style="padding: 20px 0 30px; text-align: center; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" width="13%">
                          {{ (item.qty > 0 ? item.qty : item.originalQty) }}
                        </td>
                        <td style="padding: 20px 0 30px; text-align: right; border-top: #eee 1px solid; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 16px; line-height: 1.6em;" width="17%">
                          {{ currencySign + formatPrice(item.totalPrice, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}
                        </td>
                      </tr>

                      <tr v-for="(item, index) in footers" :key="'printfooter' + index" style="border-top: 2px solid #333; font-weight: 700;">
                        <td style="padding: 5px 0; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;" colspan="2">
                          {{ item.name }}
                        </td>
                        <td style="padding: 5px 0; text-align: right; border-top: 2px solid #333; font-weight: 700; font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif; font-size: 14px; line-height: 1.6em;">
                          {{ currencySign + formatPrice(item.total, currencyDecimals, currencyDecimalSign, currencyThousandSeparator) }}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>

    <map-view ref="mapView" :latitude="shippingLatitude" :longitude="shippingLongitude"></map-view>

  </div>
</template>

<style scoped>

  .media {
    height: 100%;
    margin: 0;
  }

  table.v-table tbody td:first-child {
    padding: 15px 15px;
  }

  .item-name {
    padding: 5px !important;
  }

  .item-thumb {
    width: 60px;
    height: auto;
  }
</style>

<script>
import SideDrawer from '@/components/SideDrawer.vue'
import axios from 'axios'
import router from '../router'
import MapView from '@/components/MapView.vue'
import Loading from '@/components/Loading.vue'
import IntegrationUfi from '@/components/IntegrationUfi.vue'
import Trumbowyg from 'vue-trumbowyg'
import 'trumbowyg/dist/ui/trumbowyg.css'
import { Timeline, TimelineItem, TimelineTitle } from 'vue-cute-timeline'

let $ = window.$

export default {
  props: [
    'salesOrderNo'
  ],
  components: {
    SideDrawer,
    MapView,
    Loading,
    Trumbowyg,
    Timeline,
    TimelineItem,
    TimelineTitle,
    IntegrationUfi
  },
  data () {
    return {
      profile: this.$store.getters.getProfile,
      def: this.$store.getters.getDef,
      drawer: false,
      loading: false,
      dialogAcceptOrder: false,
      dialogAddIssue: false,
      frmAddIssueValid: false,
      issueItem: null,
      txtIssueTitle: '',
      txtIssueDetails: '',
      dialogReplyIssue: false,
      frmReplyIssueValid: false,
      txtIssueTicketId: '',
      txtReplyIssueMessage: '',
      dialogCloseIssue: false,
      frmCloseIssueValid: false,
      txtCloseIssueMessage: '',
      dialogReopenIssue: false,
      frmReopenIssueValid: false,
      txtReopenIssueMessage: '',
      menuItems: [
        { title: 'Print' }
      ],
      shipmentDialogHeaders: [
        {
          text: 'Item Name',
          align: 'left',
          sortable: false,
          value: 'name'
        },
        { text: 'Sent Qty', value: 'sentQty', align: 'center', sortable: false },
        { text: 'Qty', value: 'qty', align: 'center', sortable: false }
      ],
      invoiceNo: '',
      buyerUserId: '',
      createdDateTime: '',
      paidDateTime: '',
      shippingTitle: '',
      shippingFirstName: '',
      shippingLastName: '',
      shippingCompany: '',
      shippingAddress: '',
      shippingPostCode: '',
      shippingCityId: '',
      shippingCityName: '',
      shippingProvinceId: '',
      shippingProvinceName: '',
      shippingCountryId: '',
      shippingCountryName: '',
      shippingPhone: '',
      shippingTaxId: '',
      shippingTaxIdLocalName: '',
      shippingEmail: '',
      shippingLatitude: 0,
      shippingLongitude: 0,
      remarks: '',
      orderType: '',
      isChargebackUser: '0',
      userChargebackDateTime: '',
      payments: [],
      paymentStatus: '',
      paymentMethodName: '',
      declareValuePercentage: 0,
      deliveryStatus: '',
      customerSelectedCourierId: '',
      customerSelectedServiceCode: '',
      salesOrderDeliveredDO: [],
      courierName: '',
      serviceCode: '',
      currencyCode: '',
      currencySign: '',
      currencyDecimals: 0,
      currencyDecimalSign: '',
      currencyThousandSeparator: '',
      exchangeRateToBase: 1,
      deliveryCostBeforeSubsidy: '',
      shippingSubsidy: '',
      deliveryCost: 0,
      importTariff: 0,
      orderItems: [],
      footers: [],
      events: [],
      userNotes: [],
      shippingSubsidyToBeCollected: 0,
      shippingSubsidyToReimburse: 0,
      totalSales: 0,
      totalWeight: 0,
      dialogShipment: false,
      frmShipmentValid: false,
      totalShippingWeight: 0,
      cboCourier: null,
      cboService: null,
      txtCustomCourierName: '',
      txtCustomTrackingUrl: '',
      txtTrackingNo: '',
      txtMessage: '',
      fileUploads: [],
      bankAccounts: [],
      companyInfo: null,
      couriers: [],
      courierServices: [],
      erp: [],
      dialogViewErpSyncDetails: false,
      isPrinted: '0',
      printedDateTime: '',
      printedByUserId: '',
      printedByUserEmail: '',
      trumbowygConfig: {
        removeformatPasted: true
      }
    }
  },
  computed: {
  },
  mounted () {
    console.log($)
    this.openDrawerForDesktop()
    this.getSalesOrderDetails()
    this.disableBottomDetector()
  },

  watch: {
    cboCourier (newValue, oldValue) {
      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === newValue) {
          this.courierServices = this.couriers[c].rates
          break
        }
      }
    },
    orderItems: {
      // This will let Vue know to look inside the array
      deep: true,

      // Will fire as soon as the component is created
      immediate: true,

      // We have to move our method to a handler field
      handler: function (val, oldVal) {
        var total = 0
        for (var i in val) {
          total += (val[i].shippingQty * val[i].unitWeight)
        }
        this.totalShippingWeight = total

        // reset courier selection
        this.couriers = []
        this.courierServices = []
        this.cboCourier = null
        this.cboService = null
      }
    }
  },

  methods: {
    showMapView: function () {
      this.$refs.mapView.showMap()
    },
    checkItemIntegration: function (item) {
      if (item.integrationId && item.integrationId.length > 0) {
        for (let i in this.profile.storeIntegrations) {
          if (this.profile.storeIntegrations[i].integrationId === item.integrationId) {
            return true
          }
        }
      }
      return false
    },
    showItemIntegrationDialog: function (item) {
      if (item.integrationId === 'UFI') {
        this.$refs.integrationUfi.showIntegrationDialog(item)
      }
    },
    pickFile: function () {
      this.$refs.filePicker.click()
    },
    onFilePicked: function (e) {
      const files = e.target.files
      console.log(files)

      if (files.length + this.fileUploads.length > 3) {
        window.alert('You can only upload maximum of 3 files')
        return false
      }

      for (let i = 0; i < files.length; i++) {
        if (typeof files[i] === 'object') {
          if (files[i].name.lastIndexOf('.') <= 0) {
            return
          }

          const fr = new FileReader()
          fr.readAsDataURL(files[i])
          var _this = this
          fr.addEventListener('load', () => {
            _this.fileUploads.push({
              name: files[i].name,
              url: fr.result,
              file: files[i]
            })
          })
        }
      }
    },
    removeFileUpload: function (fileIndex) {
      this.fileUploads.splice(fileIndex, 1)
    },
    showShippingDialog: function () {
      this.couriers = []
      this.frmShipmentValid = false
      this.cboCourier = null
      this.cboService = null
      this.txtCustomCourierName = ''
      this.txtCustomTrackingUrl = ''
      this.txtTrackingNo = ''
      this.txtMessage = ''
      this.fileUploads = []
      this.dialogShipment = true
    },
    validateShippingForm: function () {
      let physicalItemCount = 0
      let virtualItemCount = 0
      for (var i in this.orderItems) {
        if (this.orderItems[i].shippingQty > 0) {
          if (this.orderItems[i].unitWeight > 0) {
            physicalItemCount = physicalItemCount + 1
          } else {
            virtualItemCount = virtualItemCount + 1
          }
        }
      }

      // validation
      if (physicalItemCount === 0 && virtualItemCount === 0) {
        window.alert('Please specify item for shipment')
        return false
      } else if (physicalItemCount > 0 && virtualItemCount > 0) {
        window.alert('Can\'t mix physical item & virtual item in shipment')
        return false
      } else if (virtualItemCount > 1) {
        window.alert('Can\'t ship multiple virtual item together')
        return false
      }

      return true
    },
    showReopenIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtReopenIssueMessage = ''
      this.frmReopenIssueValid = false
      this.dialogReopenIssue = true
    },
    reopenIssue () {
      if (this.$refs.frmReopenIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/reply', {
          message: this.txtReopenIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogReopenIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to reopen issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showCloseIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtCloseIssueMessage = ''
      this.frmCloseIssueValid = false
      this.dialogCloseIssue = true
    },
    closeIssue () {
      if (this.$refs.frmCloseIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/close', {
          message: this.txtCloseIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogCloseIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to close issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showReplyIssueDialog: function (ticketId) {
      this.txtIssueTicketId = ticketId
      this.txtReplyIssueMessage = ''
      this.frmReplyIssueValid = false
      this.dialogReplyIssue = true
    },
    replyIssue () {
      if (this.$refs.frmReplyIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/' + this.txtIssueTicketId + '/reply', {
          message: this.txtReplyIssueMessage
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogReplyIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to reply issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    showAddIssueDialog: function (issueItem) {
      this.issueItem = issueItem
      this.txtIssueTitle = ''
      this.txtIssueDetails = ''
      this.frmAddIssueValid = false
      this.dialogAddIssue = true
    },
    addIssue () {
      if (this.$refs.frmAddIssue.validate()) {
        this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/ticket/sales/item/issue', {
          salesOrderNo: this.issueItem.salesOrderNo,
          sku: this.issueItem.sku,
          paramHash: this.issueItem.paramHash,
          title: this.txtIssueTitle,
          message: this.txtIssueDetails
        })
          .then(resp => {
            this.loading = false
            if (resp.data.status === 'success') {
              this.dialogAddIssue = false
              this.getSalesOrderDetails()
            } else {
              window.alert('Unable to add issue: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    selectCourier: function (courierId) {
      if (courierId === 'CUSTOM') {
        this.txtCustomCourierName = ''
        this.txtCustomTrackingUrl = ''
      }

      for (var c = 0; c < this.couriers.length; ++c) {
        if (this.couriers[c].courierId === courierId) {
          this.courierServices = this.couriers[c].rates
        }
      }
    },
    generateShippingQtyDropdown: function (qty) {
      var result = []
      for (var i = qty; i >= 0; i--) {
        result.push(
          {
            caption: i,
            value: i
          })
      }
      return result
    },
    clickMenu: function (menuTitle) {
      var _this = this
      switch (menuTitle) {
        case 'Print':
          setTimeout(function () {
            var divToPrint = document.getElementById('printMe')
            var newWin = window.open('')
            newWin.document.write(divToPrint.outerHTML)
            newWin.document.close()

            newWin.onload = function () { // wait until all resources loaded
              newWin.focus() // necessary for IE >= 10
              newWin.print() // change window to mywindow
              newWin.close() // change window to mywindow
            }
          }, 250)
          // Delayed fire-and-forget: call print API after 700ms to avoid interfering with the print process
          setTimeout(function () {
            axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/print')
              .then(function () {
                _this.getSalesOrderDetails()
              })
              .catch(function () {
                // silently ignore - print API failure should not affect the print process
              })
          }, 700)
          break
      }
    },
    getCourierRates: function () {
      var userProfile = this.getUserProfile()
      if (this.totalShippingWeight <= 0) {
        this.couriers = [{
          courierId: 'COU-INSTANT',
          courierName: 'Instant Shipment',
          countryId: userProfile.storeCountryId,
          cityId: userProfile.storeCityId,
          status: 'active',
          countryName: userProfile.storeCountryName,
          rates: [{
            service: 'EMAIL',
            description: 'Email',
            weightLimit: 0,
            packageCount: 1,
            cost: {
              value: 0,
              etd: '1',
              note: ''
            }
          }]
        }]
      } else {
        var queryString
        if (this.shippingCityId.length > 0) {
          queryString = 'destination_city_id=' + this.shippingCityId

          if (this.profile.storeLatitude !== 0 && this.profile.storeLongitude !== 0) {
            queryString += '&origin_latitude=' + this.profile.storeLatitude + '&origin_longitude=' + this.profile.storeLongitude
          }

          if (this.shippingLatitude !== 0 && this.shippingLongitude !== 0) {
            queryString += '&destination_latitude=' + this.shippingLatitude + '&destination_longitude=' + this.shippingLongitude
          }
        } else if (this.shippingProvinceId.length > 0) {
          queryString = 'destination_province_id=' + this.shippingProvinceId
        } else {
          queryString = 'destination_country_id=' + this.shippingCountryId
        }

        this.couriers = []
        this.loading = true
        axios.get(process.env.VUE_APP_API_ROOT + '/v1/shipping/rates?weight=' + this.totalShippingWeight + '&origin_city_id=' + userProfile.storeCityId + '&' + queryString)
          .then(resp => {
            if (resp.data.status === 'success') {
              this.loading = false
              this.dialogShipment = true
              this.couriers = resp.data.data
              this.couriers.push({
                courierId: 'CUSTOM',
                courierName: 'Custom Courier',
                status: 'active',
                rates: []
              })
            } else {
              console.log('unable to get couriers: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log('get couriers : ' + error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + this.$route.fullPath)
              }
              this.loading = false
            }
          })
      }
    },
    getSalesOrderDetails: function () {
      var _this = this
      _this.loading = true
      axios.get(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo)
        .then(resp => {
          this.loading = false
          if (resp.data.status === 'success') {
            this.invoiceNo = resp.data.data.invoiceNo
            this.buyerUserId = resp.data.data.userId
            this.createdDateTime = resp.data.data.createdDateTime
            this.paidDateTime = resp.data.data.paidDateTime
            this.isChargebackUser = resp.data.data.isChargebackUser
            this.userChargebackDateTime = resp.data.data.userChargebackDateTime
            this.shippingTitle = resp.data.data.shippingTitle
            this.shippingFirstName = resp.data.data.shippingFirstName
            this.shippingLastName = resp.data.data.shippingLastName
            this.shippingCompany = resp.data.data.shippingCompany
            this.shippingAddress = resp.data.data.shippingAddress
            this.shippingPostCode = resp.data.data.shippingPostCode
            this.shippingCityId = resp.data.data.shippingCityId
            this.shippingCityName = resp.data.data.shippingCityName
            this.shippingProvinceId = resp.data.data.shippingProvinceId
            this.shippingProvinceName = resp.data.data.shippingProvinceName
            this.shippingCountryId = resp.data.data.shippingCountryId
            this.shippingCountryName = resp.data.data.shippingCountryName
            this.shippingPhone = resp.data.data.shippingPhone
            this.shippingTaxId = resp.data.data.shippingTaxId
            this.shippingTaxIdLocalName = resp.data.data.shippingTaxIdLocalName
            this.shippingEmail = resp.data.data.shippingEmail
            this.shippingLatitude = resp.data.data.shippingLatitude
            this.shippingLongitude = resp.data.data.shippingLongitude
            this.remarks = resp.data.data.remarks
            this.orderType = resp.data.data.type
            this.paymentStatus = resp.data.data.paymentStatus
            if (this.paymentStatus !== 'none') {
              let methodNamesObject = {}
              let methodNames = ''
              for (var j in resp.data.data.payments) {
                // filter distinct methods only
                if (typeof methodNamesObject[resp.data.data.payments[j].paymentMethodName] === 'undefined') {
                  methodNamesObject[resp.data.data.payments[j].paymentMethodName] = resp.data.data.payments[j].paymentMethodName
                  if (methodNames !== '') {
                    methodNames = methodNames + ', '
                  }
                  methodNames = methodNames + resp.data.data.payments[j].paymentMethodName
                }
              }
              this.paymentMethodName = methodNames
            } else {
              this.paymentMethodName = resp.data.data.paymentMethodName
            }
            this.declareValuePercentage = resp.data.data.declareValuePercentage
            this.deliveryStatus = resp.data.data.deliveryStatus
            this.courierName = resp.data.data.courierName
            this.serviceCode = resp.data.data.serviceCode
            this.customerSelectedCourierId = resp.data.data.courierId
            this.customerSelectedServiceCode = resp.data.data.serviceCode
            this.salesOrderDeliveredDO = resp.data.data.deliveryOrders

            this.exchangeRateToBase = resp.data.data.exchangeRateToBase
            this.currencyCode = resp.data.data.currencyCode
            this.currencySign = resp.data.data.currencySign
            this.currencyDecimals = resp.data.data.currencyDecimals
            this.currencyDecimalSign = resp.data.data.currencyDecimalSign
            this.currencyThousandSeparator = resp.data.data.currencyThousandSeparator
            this.deliveryCostBeforeSubsidy = resp.data.data.deliveryCostBeforeSubsidy
            this.shippingSubsidy = resp.data.data.shippingSubsidy
            this.deliveryCost = resp.data.data.deliveryCost
            this.importTariff = resp.data.data.importTariff
            this.totalSales = resp.data.data.totalSales
            this.totalWeight = resp.data.data.totalWeight

            this.shippingSubsidyToBeCollected = resp.data.data.shippingSubsidyToBeCollected
            this.shippingSubsidyToReimburse = resp.data.data.shippingSubsidyToReimburse

            for (var c in resp.data.data.items) {
              if (resp.data.data.items[c].images.length > 0) {
                resp.data.data.items[c].image = resp.data.data.items[c].imageThumbUrl ||
                  resp.data.data.items[c].imageSmallUrl ||
                  (resp.data.data.items[c].images[0] && resp.data.data.items[c].images[0].thumbUrl) ||
                  (resp.data.data.items[c].images[0] && resp.data.data.items[c].images[0].smallUrl)
              } else {
                resp.data.data.items[c].image = ''
              }
              resp.data.data.items[c].totalPrice = resp.data.data.items[c].qty * resp.data.data.items[c].unitPrice
              resp.data.data.items[c].totalPriceInBase = resp.data.data.items[c].qty * resp.data.data.items[c].unitPriceInBase
              if (resp.data.data.items[c].shipViaSellerUserId === this.profile.storeId) {
                resp.data.data.items[c].availableQty = resp.data.data.items[c].incomingQty - resp.data.data.items[c].sentQty
              } else {
                resp.data.data.items[c].availableQty = resp.data.data.items[c].qty - resp.data.data.items[c].sentQty
              }
              resp.data.data.items[c].shippingQty = resp.data.data.items[c].availableQty
            }
            this.orderItems = resp.data.data.items

            var courierName = this.courierName + ' - ' + this.serviceCode
            if (this.shippingSubsidy > 0) {
              courierName += ' (' + this.currencySign + this.formatPrice(this.deliveryCostBeforeSubsidy, this.currencyDecimals, this.currencyDecimalSign, this.currencyThousandSeparator) + ' - ' + this.currencySign + this.formatPrice(this.shippingSubsidy, this.currencyDecimals, this.currencyDecimalSign, this.currencyThousandSeparator) + ' Free Shipping)'
            }
            var footers = [
              { name: 'Subtotal', total: this.totalSales, totalInBase: this.totalSales * this.exchangeRateToBase },
              { name: courierName, total: this.deliveryCost, totalInBase: this.deliveryCost * this.exchangeRateToBase }
            ]
            if (this.importTariff > 0) {
              footers.push(
                { name: 'Import Duties', total: this.importTariff, totalInBase: this.importTariff * this.exchangeRateToBase }
              )
            }
            footers.push(
              { name: 'Grand Total', total: this.totalSales + this.deliveryCost + this.importTariff, totalInBase: (this.totalSales + this.deliveryCost + this.importTariff) * this.exchangeRateToBase }
            )
            this.footers = footers
            this.events = resp.data.data.events
            this.userNotes = resp.data.data.userNotes
            this.erp = resp.data.data.erp
            this.isPrinted = resp.data.data.isPrinted
            this.printedDateTime = resp.data.data.printedDateTime
            this.printedByUserId = resp.data.data.printedByUserId
            this.printedByUserEmail = resp.data.data.printedByUserEmail
          } else {
            console.log('unable to load sales order details: ' + resp.data.message)
          }
        })
        .catch(function (error) {
          if (error.response) {
            console.log(this)
            console.log(error.response.status)
            if (error.response.status === 401) {
              router.push('/login?next=' + _this.$route.fullPath)
            }
            _this.loading = false
          }
        })
    },
    shipOrder () {
      var _this = this
      if (_this.$refs.frmShipment.validate()) {
        _this.loading = true

        // inject files
        var i, j
        var isUploadFile = false
        var formData = new FormData()
        for (i in _this.fileUploads) {
          if (typeof _this.fileUploads[i].uploadStatus === 'undefined' || _this.fileUploads[i].uploadStatus !== 'success') {
            formData.append('file' + (parseInt(i) + 1), _this.fileUploads[i].file, _this.fileUploads[i].name)
            _this.fileUploads[i].uploadStatus = 'uploading'
            isUploadFile = true
          }
        }

        if (isUploadFile) {
          // upload files
          axios.post(process.env.VUE_APP_API_ROOT + '/v1/delivery/file', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
            .then(resp => {
              console.log(resp.data)
              if (resp.data.status === 'success') {
                var errorCount = 0
                for (i = 1; i <= 3; i++) {
                  if (typeof resp.data.data['file' + i] !== 'undefined' && typeof resp.data.data['file' + i].deliveryOrderFileId !== 'undefined') {
                    for (j in _this.fileUploads) {
                      if (resp.data.data['file' + i].fileName === _this.fileUploads[j].name) {
                        if (typeof resp.data.data['file' + i].deliveryOrderFileId !== 'undefined') {
                          _this.fileUploads[j].deliveryOrderFileId = resp.data.data['file' + i].deliveryOrderFileId
                          _this.fileUploads[j].uploadStatus = 'success'
                        } else {
                          _this.fileUploads[j].uploadStatus = 'error'
                          errorCount++
                        }
                        break
                      }
                    }
                  }
                }

                // only continue if all upload success
                if (errorCount === 0) {
                  _this.submitShipOrder()
                } else {
                  window.alert(errorCount + ' of the file upload failed, please retry')
                }
              } else {
                window.alert(resp.data.message)
              }
              _this.loading = false
            })
            .catch(function (error) {
              if (error.response) {
                console.log(error.response.status)
                if (error.response.status === 401) {
                  router.push('/login?next=' + _this.$route.fullPath)
                } else if (error.response.status === 403) {
                  _this.showAlert(error)
                }
                _this.loading = false
              }
            })
        } else {
          _this.submitShipOrder()
        }
      }
    },
    submitShipOrder () {
      var _this = this
      if (_this.$refs.frmShipment.validate()) {
        // Native form submission is not yet supported
        var shippingItems = []
        for (var c = 0; c < _this.orderItems.length; c++) {
          if (_this.orderItems[c].shippingQty > 0) {
            shippingItems.push({ 'sku': _this.orderItems[c].sku, 'paramHash': _this.orderItems[c].paramHash, 'qty': _this.orderItems[c].shippingQty })
          }
        }
        if (shippingItems.length <= 0) {
          window.alert('Please select item to ship')
          return false
        }

        var submitData = {
          trackingNo: _this.txtTrackingNo,
          message: _this.txtMessage,
          items: shippingItems
        }

        // inject courier id or custom courier
        if (_this.cboCourier === 'CUSTOM') {
          submitData.customCourierName = _this.txtCustomCourierName
          submitData.customTrackingUrl = _this.txtCustomTrackingUrl
        } else {
          submitData.courierId = _this.cboCourier
          submitData.serviceCode = _this.cboService
        }

        // inject files
        if (_this.fileUploads.length > 0) {
          var fileIds = []
          for (var i in _this.fileUploads) {
            fileIds.push(_this.fileUploads[i].deliveryOrderFileId)
          }
          submitData.fileIds = fileIds
        }

        _this.loading = true
        axios.post(process.env.VUE_APP_API_ROOT + '/v1/sales/' + _this.salesOrderNo + '/ship', submitData)
          .then(resp => {
            _this.loading = false
            if (resp.data.status === 'success') {
              _this.dialogShipment = false
              _this.getSalesOrderDetails()
            } else {
              window.alert('Unable to ship order: ' + resp.data.message)
            }
          })
          .catch(function (error) {
            if (error.response) {
              console.log(error.response.status)
              if (error.response.status === 401) {
                router.push('/login?next=' + _this.$route.fullPath)
              }
              _this.loading = false
            }
          })
      }
    }
  }
}
</script>
